module.exports = __webpack_public_path__ + "static/media/Network Operator Infographic - GBR Network - DesktopMobile - 18-03-2025 1.e5874b83.gif";